"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinApiActionEnum = void 0;
var FinApiActionEnum;
(function (FinApiActionEnum) {
    FinApiActionEnum[FinApiActionEnum["IMPORT"] = 0] = "IMPORT";
    FinApiActionEnum[FinApiActionEnum["PAYMENT"] = 1] = "PAYMENT";
    FinApiActionEnum[FinApiActionEnum["ADD_NEW_INTERFACE"] = 2] = "ADD_NEW_INTERFACE";
})(FinApiActionEnum || (exports.FinApiActionEnum = FinApiActionEnum = {}));
